//* IMP: This componet acts as a wrapper for the dynamic filed side pane.
// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import uuid from "react-native-uuid";
import Modal from "react-responsive-modal";
import { Toastr, Button } from "@revvsales/components";
import DynamicFieldFooter from "../DynamicFieldFooter/DynamicFieldFooter";
import { handlingJSON } from "./jsonHandling";
import {
  createCustomDynamicField,
  updateCustomDynamicField,
} from "../../../../actions/DocumentTemplateActions/templateService";
import { getDynamicFieldIDs } from "../../../../actions/DocumentTemplateActions/templateMethod";

// Actions Imports
import { DocumentTemplateActions, EditorActions } from "../../../../actions";
import { updateDocumentClickedComponentID } from "../../../../actions/DocumentActions/index";

// import utils
import { replaceTextAndApplyEntity } from "../../../../utils/draftUtils";
import { updateCellData } from "../../../RevvTable/utils";
import {
  getUpdatedParentComponent,
  getComponentFromInfo,
} from "../../../../utils/documentUtils";

// Internal Imports
import { COMMON } from "../../../../constants";

// Destructuring
const { DOCUMENT_LABELS } = COMMON;
const {
  saveDynamicField,
  toggleDynamicFieldView,
  updateFields,
  nukeDynamicFileData,
  addDynamicFieldinList,
  updateDynamicFieldinList,
  updateHoveredTemplateSectionId,
} = DocumentTemplateActions;
const { initEditorState } = EditorActions;

class CustomDynamicFieldTopBar extends Component {
  state = {
    showConfirmationPopup: false,
  };

  getSaveFieldButtonStatus = () => {
    let status = true;
    const {
      defaultSelectStatus,
      metaValidStatus,
      commonFieldStatus,
    } = this.props;
    if (commonFieldStatus && !defaultSelectStatus) {
      status = false;
    } else if (commonFieldStatus && defaultSelectStatus && metaValidStatus) {
      status = false;
    }
    return status;
  };

  _createDynamicField = () => {
    console.debug("_createDynamicField", this.state, this.props);
    const data = handlingJSON(this.props.customDynamicFieldData);
    if (Object.keys(this.props.selectedDynamicFieldForUpdate).length > 0) {
      console.debug("UPDATE");
      updateCustomDynamicField(
        this.props.selectedDynamicFieldForUpdate.id,
        data,
      )
        .then(res => {
          // this.props.addDynamicFieldinList(res.field);
          this.props.updateDynamicFieldinList(res.field);
          this.props.updateHoveredTemplateSectionId(null);
          Toastr.showToastr({
            className: "is-success toastr-message-wrap",
            message: `Successfully updated ${data.label} `,
            timeout: 2000,
          });
          setTimeout(() => {
            this.props.toggleDynamicFieldView("LIST");
          }, 1000);
          // this._updateDoc(res.field.id);
        })
        .catch(error => {
          console.error("err", error);
          if (error.response && error.response.status === 409) {
            Toastr.showToastr({
              type: "warning",
              message:
                "Oops! Field name is already exist, please choose a different name",
              timeout: 2000,
            });
          } else {
            Toastr.showToastr({
              type: "warning",
              message: "Oops! Something went wrong!!!",
              timeout: 2000,
            });
          }
        });
    } else {
      createCustomDynamicField(data)
        .then(res => {
          this.props.addDynamicFieldinList(res.field);
          this.props.updateHoveredTemplateSectionId(null);
          Toastr.showToastr({
            className: "is-success toastr-message-wrap",
            message: `Successfully created ${data.label} `,
            timeout: 2000,
          });
          this._updateDoc(res.field.id);
        })
        .catch(error => {
          console.error("err", error);
          if (error.response && error.response.status === 409) {
            Toastr.showToastr({
              type: "warning",
              message:
                "Oops! Field name is already exist, please choose a different name",
              timeout: 2000,
            });
          } else {
            Toastr.showToastr({
              type: "warning",
              message: "Oops! Something went wrong!!!",
              timeout: 2000,
            });
          }
        });
    }
  };

  _updateDoc = fieldId => {
    if (fieldId) {
      const {
        selectedText,
        section,
        editorState,
        components,
        activeComponentMeta,
      } = this.props;

      const oldFormFields = getDynamicFieldIDs(components);

      const selectedField = this.props.fields.find(
        field => field.id === fieldId,
      );
      const textToReplace = selectedField.label;
      const uniqueId = uuid.v4();
      const entityData = {
        id: uniqueId,
        dynamicFieldId: fieldId,
        selectedText,
        value: textToReplace,
      };

      const updatedEditorState = replaceTextAndApplyEntity(
        editorState,
        textToReplace,
        entityData,
        selectedText,
      );
      const { type } = section;
      if (type === "HTML") {
        const {
          undoStack = [],
          currentContent: currentSectionContent,
        } = section;
        if (currentSectionContent) {
          undoStack.push(currentSectionContent);
        }
        let updatedSection = {
          ...section,
          data: updatedEditorState.getCurrentContent(),
          undoStack,
        };
        this.props.addDynamicFieldinList(selectedField);
        updatedSection = getUpdatedParentComponent(
          components,
          activeComponentMeta,
          updatedSection,
        );
        updatedSection.oldFormFields = oldFormFields;
        this.props.saveDynamicField(updatedSection);
        this.props.updateDocumentClickedComponentID(
          section.id,
          true,
          section.type,
        );
        this.props.initEditorState(updatedEditorState, section);
      } else if (type === "Table") {
        const cellValue = {
          data: updatedEditorState.getCurrentContent(),
        };
        const tableData = getComponentFromInfo(
          components,
          section.componentMeta,
        );
        const rowID = section.rowID || section.componentMeta.tableRowId;
        const columnID = section.columnID || section.componentMeta.tableColId;
        const updatedTableData = updateCellData(
          tableData.data,
          rowID,
          columnID,
          cellValue,
        );
        delete section.tableData;
        delete section.columnID;
        delete section.rowID;
        section.data = updatedTableData;
        this.props.addDynamicFieldinList(selectedField);
        const updatedSection = getUpdatedParentComponent(
          components,
          section.componentMeta,
          cellValue,
        );
        updatedSection.oldFormFields = oldFormFields;
        this.props.saveDynamicField(updatedSection);
        this.props.updateDocumentClickedComponentID(
          activeComponentMeta.tableCellId,
          true,
          section.type,
        );
        this.props.initEditorState(updatedEditorState, section);
        this.props.toggleDynamicFieldView("LIST");
      } else {
        Toastr.showToastr({
          type: "warning",
          message: `Kindly select a ${DOCUMENT_LABELS[
            "dynamic-label"
          ].toLowerCase()} field`,
          timeout: 2000,
        });
      }
    }
  };

  _onNavigationBack = () => {
    this.setState({
      showConfirmationPopup: true,
    });
  };

  _onConfirmation = () => {
    this.setState({
      showConfirmationPopup: false,
    });
    if (Object.keys(this.props.selectedDynamicFieldForUpdate).length > 0) {
      this.props.toggleDynamicFieldView("LIST");
    } else {
      this.props.nukeDynamicFileData();
      this.props.toggleDynamicFieldView("INFO");
    }
  };

  _onClose = () => {
    this.setState({
      showConfirmationPopup: false,
    });
  };

  render() {
    console.debug("CUSTOMDYNAMICFIELDTOPBAR", this.props, this.state);
    return (
      <React.Fragment>
        <span
          className="btn-icon dynamicfieldselect-back-ico"
          data-test="customdynamicfieldtopbar-customdynamicfieldselect-back-ico"
          onClick={this._onNavigationBack}
          onKeyPress={this._onNavigationBack}
          role="button"
          tabIndex="0">
          <FontAwesomeIcon icon={["far", "angle-left"]} />
        </span>
        <span
          className="dynamicfieldselect-txt-title"
          data-test="customdynamicfieldtopbar-customdynamicfieldselect-txt-title">
          Add custom form field
        </span>
        <DynamicFieldFooter
          onDiscard={this._onNavigationBack}
          onSave={this._createDynamicField}
          disabled={this.getSaveFieldButtonStatus()}
        />
        <div className="quote-deletepopup">
          <Modal
            open={this.state.showConfirmationPopup}
            onClose={this._onClose}
            closeOnOverlayClick={false}
            center>
            <div
              className="confirmation-popup"
              data-test="customdynamicfieldtopbar-confirmation-popup">
              <div
                className="confirmation-popup-msg"
                data-test="customdynamicfieldtopbar-confirmation-popup-msg">
                {"Do you want to leave this form and discard your changes?"}
              </div>
              {/* <div className="quotedelete-description">
                {" Do you want to leave this form and discard your changes?"}
              </div> */}
              <div
                className="quote-footer"
                data-test="customdynamicfieldtopbar-confirmation-popup-footer">
                <div
                  className="quote-popup-response"
                  daat-test="customdynamicfieldtopbar-confirmation-popup-footer-response">
                  <Button
                    className="btn btn-transparent createquotepopup-footer-cancelbtn"
                    data-test="customdynamicfieldtopbar-confirmation-popup-cancelbtn"
                    onClick={this._onClose}>
                    {"No, I don't want to leave"}
                  </Button>
                  <Button
                    className="btn reject-document"
                    data-test="customdynamicfieldtopbar-confirmation-popup-okbtn"
                    onClick={this._onConfirmation}>
                    {"Yes"}
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    editorState,
    fields,
    section,
    selectedText,
    customDynamicFields,
    removeHighlightSelection,
    selectedDynamicFieldForUpdate,
  } = state.TemplateStore.dynamicFields;
  const { activeComponentMeta, components } = state.DocumentStore;
  const {
    customDynamicFieldData,
    defaultSelectStatus,
    metaValidStatus,
    commonFieldStatus,
  } = state.TemplateStore;
  return {
    editorState,
    fields,
    section,
    customDynamicFields,
    selectedText,
    customDynamicFieldData,
    defaultSelectStatus,
    metaValidStatus,
    commonFieldStatus,
    removeHighlightSelection,
    activeComponentMeta,
    components,
    selectedDynamicFieldForUpdate,
  };
};

const mapDispatchToProps = {
  saveDynamicField,
  updateFields,
  toggleDynamicFieldView,
  nukeDynamicFileData,
  addDynamicFieldinList,
  updateDynamicFieldinList,
  updateHoveredTemplateSectionId,
  initEditorState,
  updateDocumentClickedComponentID,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomDynamicFieldTopBar);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/CustomDynamicFieldSelect/CustomDynamicFieldTopBar.js